import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function ClientesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_USERS = process.env.REACT_APP_URL_USERS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_DEPARTAMENTOS_CLIENTES =
    process.env.REACT_APP_URL_DEPARTAMENTOS_CLIENTES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  // const [text, setText] = useState(false);

  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("NA");
  const [RFC, setRFC] = useState("NA");
  const [calle, setCalle] = useState("NA");
  const [numero_ext, setNumeroExt] = useState("NA");
  const [numero_int, setNumeroInt] = useState("NA");
  const [delegacion, setDelegacion] = useState("NA");
  const [estado, setEstado] = useState("CIUDAD DE MEXICO");
  const [pais, setPais] = useState("Mexico");
  const [cp, setCP] = useState("0");
  const [colonia, setColonia] = useState("NA");
  const [codigo, setCodigo] = useState("NA");
  const [ciudad, setCiudad] = useState("NA");
  const [plazo, setPlazo] = useState(0);
  const [porcentajePlazo1, setPorcentajePlazo1] = useState(100);
  const [plazo2, setPlazo2] = useState(0);
  const [porcentajePlazo2, setPorcentajePlazo2] = useState(0);
  const [regFiscal, setRegFiscal] = useState("0");
    const [usoCFDI, setusoCFDI] = useState("G01");
  const [formaPagoSAT, setFormaPagoSAT] = useState("99");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("NA");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("PPD");
  const [telefono, setTelefono] = useState("NA");
  const [email, setEmail] = useState("a@a.a");
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("6201b18c0f94f86068a741c0");
  const [selectedVendedor, setSelectedVendedor] = useState("69f8e7b4b878ca2872a52af9");
  const [observaciones, setObservaciones] = useState("NA");
  const [forma_pago, setFormaPago] = useState("Contado");
  const [requiereFactura, setRequiereFactura] = useState("No");
  const [alertasVentas, setAlertasVentas] = useState("No");
  const [alertasEdoCta, setAlertasEdoCta] = useState("No");
  const [alertasMarketing, setAlertasMarketing] = useState("No");
  const [listaPrecios, setListaPrecios] = useState(1);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("660c5eab065b7d3100a837a8");
  const [password, setPassword] = useState(
    Math.random().toString(36).substring(7)
  );
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    // U2: Asignar Codigo automático consecutivo CLI-NNNN
    axios
      .get(URL_CLIENTES, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => {
        const max = (res.data || []).reduce((m, c) => {
          const match = String(c.codigo || "").match(/CLI-(\d+)/i);
          return match ? Math.max(m, parseInt(match[1], 10)) : m;
        }, 0);
        setCodigo(`CLI-${String(max + 1).padStart(4, "0")}`);
      })
      .catch(() => setCodigo(`CLI-${Date.now().toString().slice(-4)}`));

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allGrupos = res.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setEmpresas(res.data || []))
      .catch((err) => console.log(err));
  }, []);

  const saveClientes = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios
        .post(
          URL_CLIENTES,
          {
            nombre_comercial,
            razon_social,
            RFC,
            calle,
            numero_ext,
            numero_int,
            delegacion,
            estado,
            pais,
            cp,
            colonia,
            ciudad,
            telefono,
            email,
            // grupos: selectedGrupo,
            // departamentosClientes: selectedDepartamento,
            vendedor: selectedVendedor,
            observaciones,
            ultimo_pago: "2000-01-01",
            forma_pago,
            codigo,
            calificadora: 1,
            areas: selectedArea,
            plazo,
            porcentajePlazo1: Number(porcentajePlazo1) || 100,
            plazo2: Number(plazo2) || 0,
            porcentajePlazo2: Number(porcentajePlazo2) || 0,
            empresas: selectedEmpresa || null,
            regFiscal,
            cargosk: 0,
            abonosk: 0,
            saldok: 0,
            usoCFDI,
            formaPagoSAT,
            condicionesPagoSAT,
            metodoPagoSAT,
            fiscal:"No",
            cargos:0,
            abonos:0,
            saldo:0,
            alertasVentas,
            alertasEdoCta,
            alertasMarketing,
            listaPrecios,
            requiereFactura
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          const idPost = response.data._id;
          axios
            .post(
              URL_SUCURSALES,
              {
                calle,
                numero_ext,
                numero_int,
                delegacion,
                estado,
                pais,
                cp,
                colonia,
                ciudad,
                clientes: idPost,
                alias: "Principal",
                RFC,
                razon_social,
                is_active:"Si",
                regFiscal,
                paqueteria:"NA",
                email
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Crear Cliente",
                  detalle: `${nombre_comercial}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data.message}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data.message}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data.message}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.clientes_create ? (
        <div className="card container">
          <h3 align="center">Nuevo Cliente</h3>
          <Form onSubmit={saveClientes}>
            <Row>
              {/* <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Apellido</Label>
                <Input
                  type="text"
                  placeholder="Apellido"
                  value={apellido}
                  onChange={(e) => {
                    setApellido(e.target.value);
                  }}
                />
              </Col> */}
              <Col md={3}>
                <Label>Codigo (consecutivo)</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  readOnly
                />
              </Col>
              <Col md={3}>
                <Label>Nombre Comercial</Label>
                <Input
                  type="text"
                  placeholder="Nombre Comercial"
                  value={nombre_comercial}
                  required
                  onChange={(e) => {
                    setNombreComercial(e.target.value);
                  }}
                />
              </Col>
              {/* <Col md={3}>
                <Label>Razon Social</Label>
                <Input
                  type="text"
                  placeholder="Razon Social"
                  value={razon_social}
                  onChange={(e) => {
                    setRazonSocial(e.target.value);
                  }}
                />
              </Col> 
              <Col md={3}>
                <Label>RFC</Label>
                <Input
                  type="text"
                  placeholder="RFC"
                  value={RFC}
                  onChange={(e) => {
                    setRFC(e.target.value);
                  }}
                />
              </Col>*/}

            {/* <Row>
              <Col md={6}>
                <Label>Calle</Label>
                <Input
                  type="text"
                  placeholder="Calle"
                  value={calle}
                  onChange={(e) => {
                    setCalle(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>No. Ext</Label>
                <Input
                  type="text"
                  placeholder="No. Ext"
                  value={numero_ext}
                  onChange={(e) => {
                    setNumeroExt(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>No. Int</Label>
                <Input
                  type="text"
                  placeholder="No. Int"
                  value={numero_int}
                  onChange={(e) => {
                    setNumeroInt(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Pais</Label>
                <Input
                  type="text"
                  placeholder="Pais"
                  value={pais}
                  onChange={(e) => {
                    setPais(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Estado</Label>
                <Input
                  type="select"
                  value={estado}
                  onChange={(e) => {
                    setEstado(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>

                  <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                  <option value="BAJA CALIFORNIA NORTE">BAJA CALIFORNIA NORTE</option>
                  <option value="BAJA CALIFORNIA SUR">BAJA CALIFORNIA SUR</option>
                  <option value="CAMPECHE">CAMPECHE</option>
                  <option value="CHIAPAS">CHIAPAS</option>
                  <option value="CHIHUAHUA">CHIHUAHUA</option>
                  <option value="CIUDAD DE MEXICO">CIUDAD DE MEXICO</option>
                  <option value="COAHUILA">COAHUILA</option>
                  <option value="COLIMA">COLIMA</option>
                  <option value="DURANGO">DURANGO</option>
                  <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                  <option value="GUANAJUATO">GUANAJUATO</option>
                  <option value="GUERRERO">GUERRERO</option>
                  <option value="HIDALGO">HIDALGO</option>
                  <option value="JALISCO">JALISCO</option>
                  <option value="MICHOACAN">MICHOACAN</option>
                  <option value="MORELOS">MORELOS</option>
                  <option value="NAYARIT">NAYARIT</option>
                  <option value="NUEVO LEON">NUEVO LEON</option>
                  <option value="OAXACA">OAXACA</option>
                  <option value="PUEBLA">PUEBLA</option>
                  <option value="QUERETARO">QUERETARO</option>
                  <option value="QUINTANA ROO">QUINTANA ROO</option>
                  <option value="SAN LUIS POTOSI ">SAN LUIS POTOSI</option>
                  <option value="SINALOA">SINALOA</option>
                  <option value="SONORA">SONORA</option>
                  <option value="TABASCO">TABASCO</option>
                  <option value="TAMAULIPAS">TAMAULIPAS</option>
                  <option value="TLAXCALA">TLAXCALA</option>
                  <option value="VERACRUZ">VERACRUZ</option>
                  <option value="YUCATAN">YUCATAN</option>
                  <option value="ZACATECAS">ZACATECAS</option>
                  </Input>
              </Col>
              <Col md={3}>
                <Label>Ciudad</Label>
                <Input
                  type="text"
                  placeholder="Ciudad"
                  value={ciudad}
                  onChange={(e) => {
                    setCiudad(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Delegacion</Label>
                <Input
                  type="text"
                  placeholder="Delegacion o Municipio"
                  value={delegacion}
                  onChange={(e) => {
                    setDelegacion(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Colonia</Label>
                <Input
                  type="text"
                  placeholder="Colonia"
                  value={colonia}
                  onChange={(e) => {
                    setColonia(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>CP</Label>
                <Input
                  type="number"
                  placeholder="CP"
                  value={cp}
                  onChange={(e) => {
                    setCP(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Telefono</Label>
                <Input
                  type="text"
                  placeholder="Telefono"
                  value={telefono}
                  onChange={(e) => {
                    setTelefono(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Email</Label>
                <Input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Vendedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedVendedor}
                  onChange={(e) => {
                    setSelectedVendedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      );
                    })}
                </Input>
              </Col>
            </Row> */}

            
              <Col md={3}>
                <Label className="mr-sm-2">Vendedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedVendedor}
                  onChange={(e) => setSelectedVendedor(e.target.value)}
                >
                  <option value="0">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => (
                      <option key={a._id} value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    ))}
                </Input>
              </Col>
              </Row>
              <Row>
              <Col md={3}>
                <Label>Forma de Pago</Label>
                <Input
                  type="select"
                  placeholder="Forma de Pago"
                  value={forma_pago}
                  onChange={(e) => {
                    setFormaPago(e.target.value);
                  }}
                >
                  <option value="0">Forma de Pago</option>
                  <option value="Contado">Contado</option>
                  <option value="Credito">Credito</option>
                </Input>
              </Col>

              <Col md={2}>
                <Label>Requiere Factura</Label>
                <Input
                  type="select"
                  value={requiereFactura}
                  onChange={(e) => setRequiereFactura(e.target.value)}
                >
                  <option value="No">No</option>
                  <option value="Si">Sí</option>
                </Input>
              </Col>

              <Col md={2}>
                <Label>Plazo 1 (dias)</Label>
                <Input
                  type="select"
                  value={plazo}
                  onChange={(e) => setPlazo(e.target.value)}
                >
                  <option value="">Plazo</option>
                  <option value="0">0 (contra entrega)</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="60">60</option>
                  <option value="90">90</option>
                  <option value="120">120</option>
                  <option value="150">150</option>
                  <option value="180">180</option>
                </Input>
              </Col>
              <Col md={1}>
                <Label>% Plazo 1</Label>
                <Input
                  type="number"
                  min="0"
                  max="100"
                  step="any"
                  value={porcentajePlazo1}
                  onChange={(e) => setPorcentajePlazo1(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Label>Plazo 2 (dias)</Label>
                <Input
                  type="select"
                  value={plazo2}
                  onChange={(e) => setPlazo2(e.target.value)}
                >
                  <option value="0">0 (sin segundo plazo)</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="60">60</option>
                  <option value="90">90</option>
                  <option value="120">120</option>
                  <option value="150">150</option>
                  <option value="180">180</option>
                </Input>
              </Col>
              <Col md={1}>
                <Label>% Plazo 2</Label>
                <Input
                  type="number"
                  min="0"
                  max="100"
                  step="any"
                  value={porcentajePlazo2}
                  onChange={(e) => setPorcentajePlazo2(e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Empresa</Label>
                <Input
                  type="select"
                  value={selectedEmpresa}
                  onChange={(e) => setSelectedEmpresa(e.target.value)}
                >
                  <option value="">Selecciona una Empresa</option>
                  {empresas
                    .filter((e) => !e.is_active || e.is_active === "Si")
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((e) => (
                      <option key={e._id} value={e._id}>
                        {e.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Almacen</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedArea}
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un almacen</option>
                  {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                        })}
                </Input>
              </Col>

              {/* Email y teléfono: se usan para mandarle la nota al cliente */}
              <Col md={3}>
                <Label className="mr-sm-2">
                  Email{" "}
                  <i
                    className="fas fa-info-circle"
                    title="Puedes capturar varios correos separados por coma. La nota se manda a todos."
                  ></i>
                </Label>
                <Input
                  type="text"
                  placeholder="correo@cliente.com, otro@cliente.com"
                  value={email === "a@a.a" ? "" : email}
                  onChange={(e) => {
                    setEmail(e.target.value || "a@a.a");
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Telefono</Label>
                <Input
                  type="text"
                  placeholder="Telefono"
                  value={telefono === "NA" ? "" : telefono}
                  onChange={(e) => {
                    setTelefono(e.target.value || "NA");
                  }}
                />
              </Col>

              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista de Precios</Label>
                <Input
                  type="select"
                  value={listaPrecios}
                  onChange={(e) => {
                    setListaPrecios(e.target.value);
                  }}
                >
                  <option value={1}>Lista 1</option>
                  <option value={2}>Lista 2</option>
                  <option value={3}>Lista 3</option>
                  <option value={4}>Lista 4</option>
                  </Input>
              </Col>
            </Row>

            {/* <Row>
            <Col md={3}>
                <Label>Regimen Fiscal</Label>
                <Input
                  type="select"
                  placeholder="RegFiscal"
                  value={regFiscal}
                  onChange={(e) => {
                    setRegFiscal(e.target.value);
                  }}
                >
                <option value="">Selecciona</option>
                  <option value="0">0</option>
                  <option value="601">601 General de Ley Personas Morales</option>
                  <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                  <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                  <option value="608">608 Demas Ingresos</option>
                  <option value="612">612 Personas Físicas con Actividades Empresariales y Profesionales</option>
                  <option value="616">616 Sin Obligacion Fiscal</option>
                  <option value="621">621 Incorporacion Fiscal</option>
                  <option value="623">623 Opcional para Grupos de Sociedades</option>
                  <option value="624">624 Régimen de los Coordinados</option>
                  <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                  <option value="626">626 Regimen simplificado de Confianza</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Uso de CDFI
                </Label>
                <Input
                  type="select"
                  placeholder="Uso de CDFI"
                  value={usoCFDI}
                  onChange={(e) => {
                    setusoCFDI(e.target.value);
                  }}
                >
                <option value="">Selecciona</option>
                  <option value="G01">G01 Adquisición de mercancías</option>
                  <option value="G03">G03 Gastos en general</option>
                  <option value="G23">G23 Opcional para grupos de sociedades</option>
                  <option value="S01">S01 Sin efectos fiscales</option>
                  </Input>
              </Col>
              <Col md={3}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSAT}
                  onChange={(e) => {
                    setFormaPagoSAT(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label>Metodo Pago Fiscal</Label>
                <Input
                  type="select"
                  value={metodoPagoSAT}
                  onChange={(e) => {
                    setMetodoPagoSAT(e.target.value);
                  }}
                >

              <option value="">Selecciona</option>
              <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
              <option value="PPD">PPD (Pago en Parcialidades o Diferido)</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label>Condiciones de Pago Fiscal</Label>
                <Input
                  type="text"
                  value={condicionesPagoSAT}
                  onChange={(e) => {
                    setCondicionesPagoSAT(e.target.value);
                  }}
                />
              </Col>
            </Row> */}


           {/* <Row>
             <Col md={3}>
                <Label className="mr-sm-2">Alertas Ventas</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasVentas}
                  onChange={(e) => {
                    setAlertasVentas(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Alertas Estado Cuenta</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasEdoCta}
                  onChange={(e) => {
                    setAlertasEdoCta(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Alertas Marketing</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasMarketing}
                  onChange={(e) => {
                    setAlertasMarketing(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col> 
              
            </Row>*/}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/Clientes"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
      
    </>
  );
}

export default ClientesCreate;
